<template>
  <div
    class="bulk-selection-bar"
    role="toolbar"
    :aria-label="ariaLabel"
    :style="positionStyle"
    :data-testid="`${testIdPrefix}__bulk-selection-bar`"
  >
    <div
      class="bulk-selection-bar__inner d-flex align-center"
      :data-testid="`${testIdPrefix}__bulk-list`"
    >
      <div class="bulk-selection-bar__selection d-flex align-center">
        <span
          class="bulk-selection-bar__count"
          :data-testid="`${testIdPrefix}__bulk-selection-count`"
        >
          {{ selectedCount }}
        </span>
        <span
          class="bulk-selection-bar__selected-label"
          :data-testid="`${testIdPrefix}__bulk-selected-label`"
        >
          Selected
        </span>
      </div>

      <div class="bulk-selection-bar__divider" aria-hidden="true" />

      <span
        v-if="sectionLabel"
        class="bulk-selection-bar__section-label"
        :data-testid="`${testIdPrefix}__bulk-section-label`"
      >
        {{ sectionLabel }}
      </span>

      <v-tooltip
        v-if="actionsTooltip && actionsTooltip.show"
        top
        content-class="tooltip-top"
      >
        <template #activator="{ on, attrs }">
          <span
            class="bulk-selection-bar__actions-wrap d-flex align-center"
            :class="{ 'bulk-selection-bar__actions-wrap--locked': actionsTooltip.locked }"
            v-bind="attrs"
            v-on="on"
          >
            <bulk-selection-bar-actions
              :actions="visibleActions"
              :loading="loading"
              :test-id-prefix="testIdPrefix"
              @action="$emit('action', $event)"
            />
          </span>
        </template>
        <span>{{ actionsTooltip.text }}</span>
      </v-tooltip>

      <bulk-selection-bar-actions
        v-else
        :actions="visibleActions"
        :loading="loading"
        :test-id-prefix="testIdPrefix"
        @action="$emit('action', $event)"
      />

      <div
        class="bulk-selection-bar__divider bulk-selection-bar__divider--trailing"
        aria-hidden="true"
      />

      <button
        type="button"
        class="bulk-selection-bar__dismiss"
        aria-label="Clear selection"
        :data-testid="dismissTestId || `${testIdPrefix}__bulk-dismiss`"
        @click="$emit('clear-selection')"
      >
        <img
          v-if="dismissIconSrc"
          :src="dismissIconSrc"
          alt=""
          class="bulk-selection-bar__dismiss-icon"
          width="16"
          height="16"
        />
        <v-icon v-else small>mdi-close</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
import BulkSelectionBarActions from './BulkSelectionBarActions.vue';
import './BulkSelectionBar.scss';

export default {
  name: 'BulkSelectionBar',
  components: {
    BulkSelectionBarActions,
  },
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sectionLabel: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
    actionsTooltip: {
      type: Object,
      default: null,
    },
    testIdPrefix: {
      type: String,
      default: 'bulk-selection-bar',
    },
    ariaLabel: {
      type: String,
      default: 'Bulk actions',
    },
    dismissIconSrc: {
      type: String,
      default: '',
    },
    dismissTestId: {
      type: String,
      default: '',
    },
    bottomOffset: {
      type: String,
      default: 'var(--bulk-action-bar-bottom)',
    },
  },
  computed: {
    visibleActions() {
      return (this.actions || []).filter((action) => !action.hidden);
    },
    positionStyle() {
      return {
        bottom: this.bottomOffset,
      };
    },
  },
};
</script>
